// extracted by mini-css-extract-plugin
module.exports = {"wish_badge":"WishButton_wish_badge__Xlj_l"};